const projectsData = [
  {
    id: 1,
    title: "EFA Logistics System",
    description: "Package tracking system with OCR integration and Firebase real-time data management.",
    techStack: ["Laravel", "Firebase", "OCR", "MySQL"],
    github: "",
    featured: true
  },
  {
    id: 2,
    title: "Inventory Management System",
    description: "Web-based system for tracking inventory, purchases, and stock movements.",
    techStack: ["Laravel", "MySQL", "Tailwind CSS"],
    github: "",
    featured: true
  },
  {
    id: 3,
    title: "Expense Tracker Mobile App",
    description: "Android application with income/expense tracking, statistics, and notifications.",
    techStack: ["Android Studio", "Java", "SQLite"],
    github: "",
    featured: true
  },
  {
    id: 4,
    title: "Genset Maintenance Management System",
    description: "System for managing plant assets, maintenance schedules, and role-based access.",
    techStack: ["Laravel", "MySQL", "Role-Based Access Control"],
    github: "",
    featured: true
  }
];

export default projectsData;
